'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsCTAsContainer = function CmsCTAsContainer(props) {
  // TODO: Have to figure out how to properly get props through
  // TODO: https://product.hubteam.com/docs/frontend/changes/code-splitting.html
  return _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/cms-page/CmsAuthedCTAs');
    },
    publicComponentLoader: function publicComponentLoader() {
      return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/public-only/GetStartedCmsPublic');
    },
    authedComponentProps: _extends({}, props)
  });
};

exports.default = CmsCTAsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-page/CmsCTAsContainer.js
// module id = 769
// module chunks = 3 4